module.exports = __webpack_public_path__ + "img/img_6.8a4b793a.png";